<template>
  <v-container
    class="filter-field inner-filter-field"
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        sm12
        xs12
        style="padding-top:7px"
      >
        <v-layout
          row
          wrap
          justify-start
        >
          <v-flex
            class="filter-row"
            xs12
            sm4
            md2
          >
            <treeselect
              ref="ip"
              v-model="selected.IP"
              :multiple="true"
              :normalizer="normalizer"
              :options="filterList.IP"
              :always-open="false"
              placeholder="IP"
              :searchable="false"
            >
              <!-- <div slot="value-label" slot-scope="{ node }"></div> -->
            </treeselect>
          </v-flex>
          <v-flex
            v-show="params.category === 'all'"
            class="filter-row"
            xs12
            sm4
            md2
          >
            <treeselect
              ref="category"
              v-model="selected.category"
              :multiple="true"
              :options="filterList.category"
              :always-open="false"
              :placeholder="$t('filter.category')"
              :searchable="false"
            >
              <!-- <div slot="value-label" slot-scope="{ node }"></div> -->
            </treeselect>
          </v-flex>
          <v-flex
            class="filter-row"
            xs12
            sm4
            md2
          >
            <treeselect
              ref="language"
              v-model="selected.language"
              :multiple="true"
              :normalizer="normalizer"
              :options="filterList.language"
              :always-open="false"
              :placeholder="$t('filter.soundLang')"
              :searchable="false"
            >
              <!-- <div slot="value-label" slot-scope="{ node }"></div> -->
            </treeselect>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        sm12
        xs12
      >
        <v-layout
          class="filter-btn-wrap"
          row
          wrap
          align-center
          justify-space-between
          style="height:100%"
        >
          <v-flex
            class="filter-row"
            xs12
            sm6
            style="max-width: none;"
          >
            <v-layout
              row
              wrap
              align-center
              justify-space-between
              style="height:100%"
            >
            <v-flex style="max-width:100px;"> {{ $t('newLP.price') }} </v-flex>
            <v-flex>
              <vue-slider
                ref="price"
                v-model="selectedPrice"
                :contained="true"
                :min="minPrice"
                :max="maxPrice"
                :interval="priceStep"
                :tooltip-formatter="priceTooltipFormatter"
                :enable-cross="true"
                :tooltip-placement="['top', 'top']"
              >
              </vue-slider>
            </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            class="filter-row filter-action-row"
            xs12
            sm6
            style="max-width: none; text-align:right;"
          >
            <v-btn
              class="filter-btn l-btn"
              @click="resetFilter"
            >
              <div
                class="btn-text-field"
              >
                {{ $t('filter.resetFilter') }}
              </div>
            </v-btn>
            <v-btn
              class="filter-btn r-btn"
              @click="commitFilter"
            >
              <div
                class="btn-text-field"
              >
                {{ $t('filter.applyFilter') }}
              </div>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { bus } from '../../main'

export default {
  components: {
    Treeselect,
    VueSlider
  },
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      filterList: {
        category: [],
        language: [],
        IP: []
      },
      selected: {
        category: [],
        language: [],
        IP: []
      },
      selectedPrice: [0, 0],
      maxPrice: 0,
      minPrice: 0,
      priceStep: 1,
      usdRate: 1,
      normalizer (node) {
        return {
          id: node.code,
          label: node.name,
          children: node.countries
        }
      },
      valueConsistsOf: 'LEAF_PRIORITY'
    }
  },
  watch: {
    '$store.getters.getPinkfongProductsCategories' (newValue, old) {
      this.filterList.category = newValue.map(x => {
        return {
          id: x.id,
          label: `${x['name']} (${x['count']})`,
          nameOnly: x['name']
        }
      })
      this.updateFilters()
    }
  },
  created () {
    bus.$on('update-PF-filter', () => {
      this.updatePayload()
    })
  },
  beforeDestroy () {
    bus.$off('update-PF-filter')
  },
  mounted: function () {
    this.updateFilters()
    this.$emit('mountedInnerFilter')
  },
  methods: {
    priceTooltipFormatter (value) {
      if (this.params.lang === 'ko') {
        return `₩${value.toLocaleString()}`
      } else {
        return `$${value.toLocaleString()}`
      }
    },
    getFilterFatches () {
      const fatchs = [
        this.fatchPriceRange(),
        this.fatchIP(),
        this.fatchSoundLanguage()
      ]

      return Promise.all(fatchs)
    },
    updateFilters: function () {
      if (this.params.lang === 'home') {
        return
      }

      const categories = this.$store.getters.getPinkfongProductsCategories || []

      this.filterList.category = categories.map(x => {
        return { id: x.id, label: `${x['name']} (${x['count']})`, nameOnly: x['name'] }
      })

      this.getFilterFatches().then((values) => {
        if (this.filterList.category.length > 0) {
          this.updatePayload()
        }
      })
    },
    commitFilter () {
      this.updatePayload()
    },
    resetFilter () {
      this.selected.category = []
      this.selectedPrice = [0, 0]

      this.commitFilter()
    },
    nameWithCount ({ name, count }) {
      return `${name} (${count})`
    },
    getUpdatedSelections (key) {
      if (key === 'category') {
        if (this.$route.path.split('/')[3] !== 'all') {
          return []
        } else {
          return this.selected.category
        }
      }
      const prevSelections = [ ...this.selected[key] ]
      const filterListKey = key === 'region' ? 'allCountries' : key

      const currOptions = this.filterList[filterListKey].map(x => x.code)

      return prevSelections.filter(x => currOptions.includes(x))
    },
    updatePayload (key, value) {
      const payload = {}

      if (!this.$store.getters.isSingleFilterEmpty) {
        this.selected.IP = []
        this.selected.language = []
        this.selected.category = []
        this.selectedPrice = [0, 0]

        const singleFilter = this.$store.getters.getSingleFilter

        this.selected[singleFilter.filter].push(singleFilter.id)

        this.$store.commit('setSingleFilter', {})
      }

      // selected 있을경우 다 넣는게 아니라, filterList 에 존재 할 경우에만 넣어야 함.
      Object.keys(this.selected).forEach(key => {
        this.selected[key] = this.getUpdatedSelections(key)
      })

      payload['IP'] = this.selected.IP.length > 0 ? JSON.stringify(this.selected.IP) : JSON.stringify(this.filterList.IP.map(x => x.code))
      payload['soundLanguage'] = this.selected.language.length > 0 ? JSON.stringify(this.selected.language) : JSON.stringify(this.filterList.language.map(x => x.code))

      if (this.params.category === 'all') {
        payload['categoryFilter'] = this.selected.category.length > 0 ? JSON.stringify(this.selected.category) : JSON.stringify(this.filterList.category.map(x => x.id))
      }

      payload['selected'] = { ...this.selected }

      const selectedName = {}
      Object.keys(payload['selected']).forEach(key => {
        let nameList = []

        if (key === 'category') {
          nameList = payload['selected'][key].map(code => {
            const names = this.filterList['category'].filter(item => item.id === code)
            if (names.length > 0) {
              return names[0].nameOnly
            }
          })
          selectedName[key] = nameList
          return true
        }

        nameList = payload['selected'][key].map(code => {
          const names = this.filterList[key].filter(item => item.code === code)
          if (names.length > 0) {
            return names[0].nameOnly
          }
        })
        selectedName[key] = nameList
        return true
      })

      if (this.params.lang === 'ko') {
        payload['price'] = JSON.stringify([ ...this.selectedPrice ])
      } else {
        payload['price'] = JSON.stringify([ this.selectedPrice[0] * this.usdRate, this.selectedPrice[1] * this.usdRate ])
      }

      if (this.selectedPrice[1] > 0) {
        selectedName['price'] = [`${this.selectedPrice[0].toLocaleString()} ~ ${this.selectedPrice[1].toLocaleString()}`]
      }

      payload['selected'] = { ...selectedName }

      this.$emit('updatePayload', payload)
    },
    fatchIP () {
      return this.$http.get('/api/info/IP' + '/?lang=' + this.params.lang + '&category=' + this.params.category + '&product=pinkfongproducts')
        .then(res => {
          const noneZeroList = res.data.reduce((acc, cur) => {
            if (!cur.count) return acc
            return acc.concat({ ...cur, name: `${cur['name']} (${cur['count']})`, nameOnly: cur['name'] })
          }, [])
          this.filterList.IP = noneZeroList
          // this.selected.IP = this.filterList.IP
        })
        .catch(err => {
          console.log(err)
        })
    },
    fatchSoundLanguage () {
      return this.$http.get('/api/info/language' + '/?lang=' + this.params.lang + '&category=' + this.params.category + '&product=pinkfongproducts')
        .then(res => {
          const noneZeroList = res.data.reduce((acc, cur) => {
            if (!cur.count) return acc
            return acc.concat({ ...cur, name: `${cur['name']} (${cur['count']})`, nameOnly: cur['name'] })
          }, [])
          this.filterList.language = noneZeroList

          // this.selected.language = this.filterList.language
        })
        .catch(err => {
          console.log(err)
        })
    },
    fatchPriceRange () {
      return this.$http.get('/api/products/pricerange' + '/?lang=' + this.params.lang + '&product=pinkfongproducts')
        .then(res => {
          this.usdRate = res.data.rate.rate

          if (this.params.lang === 'ko') {
            this.priceStep = 10000
            this.maxPrice = Math.floor((res.data.maxPrice + this.priceStep) / this.priceStep) * this.priceStep
          } else {
            this.priceStep = 10
            const maxPriceUSD = res.data.maxPrice / this.usdRate
            this.maxPrice = Math.floor((maxPriceUSD + this.priceStep) / this.priceStep) * this.priceStep
          }
          this.minPrice = 0
        })
        .catch(err => {
          console.log(err)
        })
    },
    openFilter (key) {
      if (key === 'price') {
        this.$refs[key].focus(1)
        return
      }

      this.$refs[key].toggleMenu()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/app/contents/PinkfongProductFilter.vue